<template>
  <div class="voucher-transfer">
    <Voucher
      :fetch-legacy-conversions="fetchLegacyConversions"
      @user-product-info="handleUserProductInfo"
    />
  </div>
</template>
<script setup>
  import { getLegacyConversions } from '@/common/requests/data-fetch/get-legacy-conversions'
  import cookie from '@/common/utils/cookie'
  import { handleVoucher } from '@/common/utils/modal/handle-voucher'
  import {
    IOS_VOUCHER_TRANSFER,
    VOUCHER_TRANSFER,
  } from '@/common/utils/voucher/const'
  import Voucher from '@/pages/voucher/index.vue'
  import { useRoute, useRouter } from 'vue-router/composables'

  const router = useRouter()
  const route = useRoute()
  const { action } = handleVoucher()

  const emit = defineEmits(['user-product-info'])

  const handleUserProductInfo = (data) => {
    emit('user-product-info', data)
  }

  const showVoucherTransferModal = async (errorCode) => {
    const isIosError = errorCode === 403005
    const modalConfig = isIosError ? IOS_VOUCHER_TRANSFER : VOUCHER_TRANSFER
    await action.voucherTransferModal(modalConfig)
  }

  const redirectToLogin = () => {
    const { fullPath } = route
    return router.replace(`/login?referer=${fullPath}`)
  }

  const handleApiError = async (errorCode) => {
    const isCredentialError = errorCode === 401

    if (isCredentialError) {
      await redirectToLogin()
      return null
    }

    await showVoucherTransferModal(errorCode)
  }

  const fetchLegacyConversions = async () => {
    const credential =
      cookie.getCredential() === 'none' ? '' : cookie.getCredential()

    const { data, error } = await getLegacyConversions(credential)

    const errorCode = error?.data?.code
    if (errorCode) {
      return handleApiError(errorCode)
    }

    return data
  }

  const init = async () => {
    await fetchLegacyConversions()
  }

  init()
</script>
<style lang="scss" scoped>
  .voucher-transfer {
    :deep(.ticket-tab) {
      margin-top: 0;
    }
  }
</style>
